/* eslint-disable */
import * as Yup from 'yup';
import React, { useState, useEffect, useRef } from 'react';
import { Container, Card, FormControl, InputLabel, Checkbox, InputAdornment, FormHelperText, Grid } from '@material-ui/core';
import { useFormik, Form, FormikProvider } from 'formik';
import { Stack, TextField, IconButton, Box, Button } from '@material-ui/core';
import SearchNotFound from '../../../SearchNotFound';
import MenuItem from '@material-ui/core/MenuItem';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import TableContainer from '@material-ui/core/TableContainer';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import Chip from '@material-ui/core/Chip';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Page from '../../../Page';
import TokenDecoder from 'src/helpers/TokenDecoder';
import _ from 'lodash';
import permissionAuth from 'src/utils/permissionAuth';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import PropTypes, { func } from 'prop-types'
import { useTheme } from '@mui/material/styles';
import services from '../Service';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import { makeStyles } from '@material-ui/styles';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import CreatePDF from './CreatePDF';
import ReactToPrint from "react-to-print";
import xlsx from 'json-as-xlsx';
import Select from '@material-ui/core/Select';
import ClearIcon from '@mui/icons-material/Clear';
import moment from 'moment';
import { endOfMonth } from 'date-fns';


var screenCode = "YTDANDMTDSUMMARYREPORT"

function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </Box>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

function EnhancedTableHead(props) {
    const { classes, order, orderBy, onRequestSort } = props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                {headCells.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.align}
                        padding={headCell.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <span className={classes.visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </span>
                            ) : null}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    )
}

EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired
};

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%'
    },
    paper: {
        width: '100%',
        marginBottom: theme.spacing(2)
    },
    table: {
        minWidth: 750
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1
    }
}));

export default function YtdAndMtdSummaryView(props) {

    const navigate = useNavigate();
    const componentRef = useRef();
    const [csvHeaders, SetCsvHeaders] = useState([]);

    const classes = useStyles();
    const [pageProps, setPageProps] = useState({
        editingID: 0,
        isEdit: true,
        pageheadername: 'YTD and MTD Summary Report'
    });

    const [group, setGroup] = useState([]);
    const [factory, setFactory] = useState([]);
    const [fromDate, setFromDate] = useState(new Date().toISOString().substring(0, 10));
    const [toDate, setToDate] = useState(new Date().toISOString().substring(0, 10));
    const [ytdAndMtdDetails, setytdAndMtdDetails] = useState([]);
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [isEnable, setIsEnable] = useState(true);
    const [ytdAndMtdData, setytdAndMtdData] = useState({
        ytdAndMtdName: ''
    });
    const [formData, setFormData] = useState({
        groupID: 0,
        operationEntityID: '',
        fromDate: new Date(fromDate).toISOString().substring(0, 10),
        toDate: new Date(toDate).toISOString().substring(0, 10),
        isActive: true
    });
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false
    });

    const ytdAndMtdSummaryReportSchema = Yup.object().shape({
        groupID: Yup.number().min(1, 'Please Select Group').required('Group Required'),
        operationEntityID: Yup.array().required('Please select at least one Fresh collection center').min(1, 'Please select at least one Fresh collection center'),
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        groupName: '',
        factoryName: '',
        startDate: '',
        endDate: ''
    });

    const [total, setTotalRow] = useState({
        dtnetAmount: 0,
        dtfccPurchaseValue: 0,
        dtpurchaseFromECValue: 0,
        dtValueSaving: 0,
        dtSaving: 0,
        mtdfccPurchaseValue: 0,
        mtdpurchaseFromECValue: 0,
        mtdValueSaving: 0,
        mtdSaving: 0,
        mtdCost: 0,
        mtdNetProfit: 0,
        ytdfccPurchaseValue: 0,
        ytdpurchaseFromECValue: 0,
        ytdValueSaving: 0,
        ytdSaving: 0,
        ytdCost: 0,
        ytdNetProfit: 0
    });

    const formik = useFormik({
        initialValues: {
            groupID: formData.groupID,
            operationEntityID: selectedOptions,
            fromDate: fromDate,
            toDate: toDate,
            isActive: formData.isActive
        },
        validationSchema: ytdAndMtdSummaryReportSchema,
        onSubmit: (values) => {
            trackPromise(SubmitForm(values));
        },
    });

    const isFutureDateDisabled = (date) => {
        return date > new Date();
    };

    const handleFromDateChange = (newValue) => {
        setFromDate(newValue);
        var endofMonthx = endOfMonth(new Date(newValue))
        setToDate(endOfMonth(new Date(endofMonthx)));
    };

    async function SubmitForm(values) {
        let model = {
            groupID: parseInt(values.groupID),
            operationEntityID: selectedOptions.map(x => x).join(',').toString(),
            fromDate: moment(fromDate).format('YYYY-MM-DD'),
            toDate: moment(toDate).format('YYYY-MM-DD')
        }

        var res = await services.GetYTDAndMTDSummaryReportDetails(model)
        res.forEach(x => {
            x.dtfccPurchaseValue = x.fccPurchaseValue
            x.dtnetAmount = x.netAmount
            x.dtpurchaseFromECValue = x.purchaseFromECValue
            x.mtdCost = x.mtdCost
            if (x.mtdDetails.length > 0) {
                x.mtdDetails.forEach(y => {
                    x.mtdfccPurchaseValue = y.fccPurchaseValue
                    x.mtdnetAmount = y.netAmount
                    x.mtdpurchaseFromECValue = y.purchaseFromECValue
                })
            }
            else {
                x.mtdfccPurchaseValue = 0
                x.mtdnetAmount = 0
                x.mtdpurchaseFromECValue = 0
            }
            if (x.ytdDetails.length > 0) {
                x.ytdDetails.forEach(y => {
                    x.ytdfccPurchaseValue = y.fccPurchaseValue
                    x.ytdnetAmount = y.netAmount
                    x.ytdpurchaseFromECValue = y.purchaseFromECValue
                })
            }
            else {
                x.ytdfccPurchaseValue = 0
                x.ytdnetAmount = 0
                x.ytdpurchaseFromECValue = 0
            }
            x.dtValueSaving = x.dtpurchaseFromECValue == 0 ? 0 : x.dtpurchaseFromECValue - x.dtfccPurchaseValue
            x.dtSaving = x.dtpurchaseFromECValue == 0 ? 0 : (x.dtValueSaving / x.dtpurchaseFromECValue) * 100

            x.mtdValueSaving = x.mtdpurchaseFromECValue - x.mtdfccPurchaseValue
            x.mtdSaving = x.mtdpurchaseFromECValue == 0 ? 0 : (x.mtdValueSaving / x.mtdpurchaseFromECValue) * 100

            x.ytdValueSaving = x.ytdpurchaseFromECValue - x.ytdfccPurchaseValue
            x.ytdSaving = x.ytdpurchaseFromECValue == 0 ? 0 : (x.ytdValueSaving / x.ytdpurchaseFromECValue) * 100

            x.mtdNetProfit = x.mtdValueSaving == 0 ? 0 : x.mtdValueSaving - (x.mtdCost * x.netAmount)
            x.ytdNetProfit = x.ytdfccPurchaseValue == 0 ? 0 : x.ytdfccPurchaseValue - x.ytdCost
        })
        const groupBy = (array, key) => {
            return array.reduce((result, currentItem) => {
                const groupKey = currentItem[key];
                if (!result[groupKey]) {
                    result[groupKey] = [];
                }
                result[groupKey].push(currentItem);
                return result;
            }, {});
        };
        const grouped = groupBy(res, 'factoryName');
        const groupedCustomerList = Object.entries(grouped).map(([key, items]) => ({
            factoryName: key,
            details: items.sort((a, b) => a.createdDate > b.createdDate ? 1 : -1)
        }));
        groupedCustomerList.sort((a, b) => a.factoryName > b.factoryName ? 1 : -1)
        let dtnetAmount = 0;
        let dtfccPurchaseValue = 0;
        let dtpurchaseFromECValue = 0;
        let dtValueSaving = 0;
        let dtSaving = 0;

        let mtdfccPurchaseValue = 0;
        let mtdpurchaseFromECValue = 0;
        let mtdValueSaving = 0;
        let mtdSaving = 0;

        let mtdCost = 0;
        let mtdNetProfit = 0;

        let ytdfccPurchaseValue = 0;
        let ytdpurchaseFromECValue = 0;
        let ytdValueSaving = 0;
        let ytdSaving = 0;

        let ytdCost = 0;
        let ytdNetProfit = 0;

        groupedCustomerList.forEach(x => {
            x.details.forEach(y => {
                x.dtnetAmount = x.dtnetAmount == undefined ? 0 + y.dtnetAmount : x.dtnetAmount + y.dtnetAmount;
                x.dtfccPurchaseValue = x.dtfccPurchaseValue == undefined ? 0 + y.dtfccPurchaseValue : x.dtfccPurchaseValue + y.dtfccPurchaseValue;
                x.dtpurchaseFromECValue = x.dtpurchaseFromECValue == undefined ? 0 + y.dtpurchaseFromECValue : x.dtpurchaseFromECValue + y.dtpurchaseFromECValue;
                x.dtValueSaving = x.dtValueSaving == undefined ? 0 + y.dtValueSaving : x.dtValueSaving + y.dtValueSaving;
                x.dtSaving = x.dtpurchaseFromECValue == 0 ? 0 : (x.dtValueSaving / x.dtpurchaseFromECValue) * 100;

                x.mtdfccPurchaseValue = y.mtdfccPurchaseValue;
                x.mtdpurchaseFromECValue = y.mtdpurchaseFromECValue;
                x.mtdValueSaving = y.mtdValueSaving;
                x.mtdSaving = x.mtdpurchaseFromECValue == 0 ? 0 : (x.mtdValueSaving / x.mtdpurchaseFromECValue) * 100;

                x.mtdCost = y.mtdCost;
                x.mtdNetProfit = y.mtdNetProfit;

                x.ytdfccPurchaseValue = y.ytdfccPurchaseValue;
                x.ytdpurchaseFromECValue = y.ytdpurchaseFromECValue;
                x.ytdValueSaving = y.ytdValueSaving;
                x.ytdSaving = x.ytdpurchaseFromECValue == 0 ? 0 : (x.ytdValueSaving / x.ytdpurchaseFromECValue) * 100;

                x.ytdCost = y.ytdCost;
                x.ytdNetProfit = y.ytdNetProfit;
            })
            dtnetAmount = dtnetAmount + x.dtnetAmount;
            dtfccPurchaseValue = dtfccPurchaseValue + x.dtfccPurchaseValue;
            dtpurchaseFromECValue = dtpurchaseFromECValue + x.dtpurchaseFromECValue;
            dtValueSaving = dtValueSaving + x.dtValueSaving;
            dtSaving = (dtValueSaving / dtpurchaseFromECValue) * 100;

            mtdfccPurchaseValue = mtdfccPurchaseValue + x.mtdfccPurchaseValue;
            mtdpurchaseFromECValue = mtdpurchaseFromECValue + x.mtdpurchaseFromECValue;
            mtdValueSaving = mtdValueSaving + x.mtdValueSaving;
            mtdSaving = (mtdValueSaving / mtdpurchaseFromECValue) * 100;

            mtdCost = mtdCost + x.mtdCost;
            mtdNetProfit = mtdNetProfit + x.mtdNetProfit;

            ytdfccPurchaseValue = ytdfccPurchaseValue + x.ytdfccPurchaseValue;
            ytdpurchaseFromECValue = ytdpurchaseFromECValue + x.ytdpurchaseFromECValue;
            ytdValueSaving = ytdValueSaving + x.ytdValueSaving;
            ytdSaving = (ytdValueSaving / ytdpurchaseFromECValue) * 100;

            ytdCost = ytdCost + x.ytdCost;
            ytdNetProfit = ytdNetProfit + x.ytdNetProfit;
        })

        setTotalRow((prevState) => ({
            ...prevState,
            dtnetAmount: dtnetAmount,
            dtfccPurchaseValue: dtfccPurchaseValue,
            dtpurchaseFromECValue: dtpurchaseFromECValue,
            dtValueSaving: dtValueSaving,
            dtSaving: dtSaving,
            mtdfccPurchaseValue: mtdfccPurchaseValue,
            mtdpurchaseFromECValue: mtdpurchaseFromECValue,
            mtdValueSaving: mtdValueSaving,
            mtdSaving: mtdSaving,
            mtdCost: mtdCost,
            mtdNetProfit: mtdNetProfit,
            ytdfccPurchaseValue: ytdfccPurchaseValue,
            ytdpurchaseFromECValue: ytdpurchaseFromECValue,
            ytdValueSaving: ytdValueSaving,
            ytdSaving: ytdSaving,
            ytdCost: ytdCost,
            ytdNetProfit: ytdNetProfit
        }));
        setytdAndMtdDetails(groupedCustomerList);

        getSelectedDropdownValuesForReport(model);
    }

    const { errors, setValues, touched, handleSubmit, getFieldProps, values } = formik;

    useEffect(() => {
        getPermissions()
    }, []);

    async function getPermissions() {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'YTDANDMTDSUMMARYREPORT');

        if (isAuthorized === undefined) {
            navigate('/404');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
        });

        setValues({
            ...values,
            groupID: parseInt(TokenDecoder.getGroupFactoryToken().group)
        })
        trackPromise(GetAllGroups());
    }

    async function clearAll() {
        const factoryValue = parseInt(TokenDecoder.getGroupFactoryToken().factory);
        const selectedOptions = [factoryValue];
        setSelectedOptions(selectedOptions)
        setFromDate(new Date());
        setToDate(new Date());
    }

    useEffect(() => {
        trackPromise(GetAllGroups());
    }, []);

    useEffect(() => {
        trackPromise(GetFactoriesByGroupID());
    }, [formik.values.groupID]);

    useEffect(() => {
        setytdAndMtdDetails([]);
    }, [formik.values.operationEntityID]);

    useEffect(() => {
        setytdAndMtdDetails([]);
    }, [toDate]);

    useEffect(() => {
        setytdAndMtdDetails([]);
    }, [fromDate]);

    useEffect(() => {
        setytdAndMtdDetails([]);
    }, [selectedOptions]);

    useEffect(() => {
        setValues({
            ...values,
            operationEntityID: selectedOptions
        })
    }, [selectedOptions]);

    useEffect(() => {
        const factoryValue = parseInt(TokenDecoder.getGroupFactoryToken().factory);
        const selectedOptions = [factoryValue];
        setSelectedOptions(selectedOptions)
    }, [factory]);

    async function GetAllGroups() {
        var res = await services.GetAllGroups()
        if (res != null) {
            setGroup(res);
        }
    }

    async function GetFactoriesByGroupID() {
        var res = await services.GetVCCFactoriesByGroupID(formik.values.groupID)
        if (res != null) {
            var newOptionArray = [];
            for (var i = 0; i < res.length; i++) {
                newOptionArray.push({ label: res[i].factoryName, value: res[i].factoryID })
            }
            setFactory(newOptionArray);
        }
    }

    async function createFile() {
        var file = await createDataForExcel(ytdAndMtdDetails);
        var settings = {
            sheetName: 'YTD and MTD Summary Report',
            fileName: 'YTD and MTD Summary Report',
            writeOptions: {}
        }
        let keys = Object.keys(file[0])
        let tempcsvHeaders = csvHeaders;
        keys.map((sitem, i) => {
            tempcsvHeaders.push({ label: sitem, value: sitem })
        })
        let dataA = [
            {
                sheet: 'YTD and MTD Summary Report',
                columns: tempcsvHeaders,
                content: file
            }
        ]
        xlsx(dataA, settings);
    }

    const handleSelectChange = (event) => {
        const value = event.target.value;
        if (value.includes("")) {
            setSelectedOptions(selectedOptions.length === factory.length ? [] : factory.map((option) => option.value));
        } else {
            setSelectedOptions(value);
        }
    };

    const handleClearSelection = () => {
        setSelectedOptions([]);
    };

    async function createDataForExcel(array) {
        var res = [];
        if (array != null) {
            array.forEach(x => {
                x.details.forEach(y => {
                    var vr = {
                        'FCC': x.factoryName,
                        'Order Date': moment(y.createdDate).format('YYYY-MM-DD'),
                        'Qty Purchase (Kg)': y.dtnetAmount == 0 ? '-' : parseFloat(y.dtnetAmount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                        'FCC Purchase Value (Rs)': y.dtfccPurchaseValue == 0 ? '-' : parseFloat(y.dtfccPurchaseValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),

                        'If Purchased From EC Value (Rs)': y.dtpurchaseFromECValue == 0 ? '-' : parseFloat(y.dtpurchaseFromECValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                        'Value Saving (Rs)': y.dtValueSaving == 0 ? '-' : parseFloat(y.dtValueSaving).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                        'Saving (%)': y.dtSaving == 0 ? '-' : parseFloat(y.dtSaving).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                        'MTD FCC Purchase Value (Rs)': y.mtdfccPurchaseValue == 0 ? '-' : parseFloat(y.mtdfccPurchaseValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),

                        'MTD If Purchase From EC Value (Rs)': y.mtdpurchaseFromECValue == 0 ? '-' : parseFloat(y.mtdpurchaseFromECValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                        'MTD Value Saving (Rs)': y.mtdValueSaving == 0 ? '-' : parseFloat(y.mtdValueSaving).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                        'MTD Saving (%)': y.mtdSaving == 0 ? '-' : parseFloat(y.mtdSaving).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                        'MTD Operation Cost (Rs)': y.mtdCost == 0 ? '-' : parseFloat(y.mtdCost).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),

                        'MTD Net Profit Of Center (Rs)': y.mtdNetProfit == 0 ? '-' : parseFloat(y.mtdNetProfit).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                        'YTD FCC Purchase Value (Rs)': y.ytdfccPurchaseValue == 0 ? '-' : parseFloat(y.ytdfccPurchaseValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                        'YTD If Purchase From EC Value (Rs)': y.ytdpurchaseFromECValue == 0 ? '-' : parseFloat(y.ytdpurchaseFromECValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                        'YTD Value Saving (Rs)': y.ytdValueSaving == 0 ? '-' : parseFloat(y.ytdValueSaving).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),

                        'YTD Saving (%)': y.ytdSaving == 0 ? '-' : parseFloat(y.ytdSaving).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                        'YTD Operational Costs': y.ytdCost == 0 ? '-' : parseFloat(y.ytdCost).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                        'YTD Net Profit Of Center (Rs)': y.ytdNetProfit == 0 ? '-' : parseFloat(y.ytdNetProfit).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                    }
                    res.push(vr);
                });
                var vrOne = {
                    'FCC': 'Sub Total',
                    'Qty Purchase (Kg)': x.dtnetAmount == 0 ? '-' : parseFloat(x.dtnetAmount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                    'FCC Purchase Value (Rs)': x.dtfccPurchaseValue == 0 ? '-' : parseFloat(x.dtfccPurchaseValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),

                    'If Purchased From EC Value (Rs)': x.dtpurchaseFromECValue == 0 ? '-' : parseFloat(x.dtpurchaseFromECValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                    'Value Saving (Rs)': x.dtValueSaving == 0 ? '-' : parseFloat(x.dtValueSaving).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                    'MTD FCC Purchase Value (Rs)': x.mtdfccPurchaseValue == 0 ? '-' : parseFloat(x.mtdfccPurchaseValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),

                    'MTD If Purchase From EC Value (Rs)': x.mtdpurchaseFromECValue == 0 ? '-' : parseFloat(x.mtdpurchaseFromECValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                    'MTD Value Saving (Rs)': x.mtdValueSaving == 0 ? '-' : parseFloat(x.mtdValueSaving).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                    'MTD Operation Cost (Rs)': x.mtdCost == 0 ? '-' : parseFloat(x.mtdCost).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),

                    'MTD Net Profit Of Center (Rs)': x.mtdNetProfit == 0 ? '-' : parseFloat(x.mtdNetProfit).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                    'YTD FCC Purchase Value (Rs)': x.ytdfccPurchaseValue == 0 ? '-' : parseFloat(x.ytdfccPurchaseValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                    'YTD If Purchase From EC Value (Rs)': x.ytdpurchaseFromECValue == 0 ? '-' : parseFloat(x.ytdpurchaseFromECValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                    'YTD Value Saving (Rs)': x.ytdValueSaving == 0 ? '-' : parseFloat(x.ytdValueSaving).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),

                    'YTD Operational Costs': x.ytdCost == 0 ? '-' : parseFloat(x.ytdCost).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                    'YTD Net Profit Of Center (Rs)': x.ytdNetProfit == 0 ? '-' : parseFloat(x.ytdNetProfit).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                }
                res.push(vrOne);
            });
            var vrTwo = {
                'FCC': 'Total',
                'Qty Purchase (Kg)': total.dtnetAmount == 0 ? '-' : parseFloat(total.dtnetAmount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                'FCC Purchase Value (Rs)': total.dtfccPurchaseValue == 0 ? '-' : parseFloat(total.dtfccPurchaseValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),

                'If Purchased From EC Value (Rs)': total.dtpurchaseFromECValue == 0 ? '-' : parseFloat(total.dtpurchaseFromECValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                'Value Saving (Rs)': total.dtValueSaving == 0 ? '-' : parseFloat(total.dtValueSaving).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                'MTD FCC Purchase Value (Rs)': total.mtdfccPurchaseValue == 0 ? '-' : parseFloat(total.mtdfccPurchaseValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),

                'MTD If Purchase From EC Value (Rs)': total.mtdpurchaseFromECValue == 0 ? '-' : parseFloat(total.mtdpurchaseFromECValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                'MTD Value Saving (Rs)': total.mtdValueSaving == 0 ? '-' : parseFloat(total.mtdValueSaving).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                'MTD Operation Cost (Rs)': total.mtdCost == 0 ? '-' : parseFloat(total.mtdCost).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),

                'MTD Net Profit Of Center (Rs)': total.mtdNetProfit == 0 ? '-' : parseFloat(total.mtdNetProfit).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                'YTD FCC Purchase Value (Rs)': total.ytdfccPurchaseValue == 0 ? '-' : parseFloat(total.ytdfccPurchaseValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                'YTD If Purchase From EC Value (Rs)': total.ytdpurchaseFromECValue == 0 ? '-' : parseFloat(total.ytdpurchaseFromECValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                'YTD Value Saving (Rs)': total.ytdValueSaving == 0 ? '-' : parseFloat(total.ytdValueSaving).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),

                'YTD Operational Costs': total.ytdCost == 0 ? '-' : parseFloat(total.ytdCost).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                'YTD Net Profit Of Center (Rs)': total.ytdNetProfit == 0 ? '-' : parseFloat(total.ytdNetProfit).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            }
            res.push(vrTwo);
            res.push({});
            res.push({});

        }
        return res;
    }

    function getSelectedDropdownValuesForReport(data) {
        const facName = [];
        selectedOptions.forEach(x => {
            const fildered = factory.find(y => x === y.value).label
            facName.push(fildered)
        });
        let groups = group.find(x => x.groupID == formik.values.groupID)
        setSelectedSearchValues((prevState) => ({
            ...prevState,
            groupName: groups.groupName,
            factoryName: facName.length == 0 ? 'All Fresh Collection Centers' : facName.join(', '),
            startDate: data.fromDate,
            endDate: data.toDate,
        }));
    }

    const renderSelectedValue = (selected) => {
        if (selected.length === 0) {
            return '';
        } else if (selected.length === 1) {
            const option = factory.find((entity) => entity.value === selected[0]);
            return option ? <Chip label={option.label} /> : '';
        } else {
            const selectedChips = selected.map((value, index) => {
                if (index === 0) {
                    const option = factory.find((entity) => entity.value === value);
                    return option ? <Chip label={option.label} /> : null;
                } else {
                    const option = factory.find((entity) => entity.value === value);
                    return option ? <Chip key={index} label={option.label} /> : null;
                }
            });
            const moreCount = selected.length - 1;
            return (
                <div>
                    {selectedChips[0]} + {moreCount} more
                </div>
            );
        }
    };

    return (
        <>
            <LoadingComponent />
            <Page title="YTD and MTD Summary Report |  FAPS">
                <Container maxWidth>
                    <CommonPageHeader pageName={pageProps.pageheadername} leftButtonHidden={true} />
                    <FormikProvider value={formik}>
                        <ToastContainer position="bottom-right" pauseOnHover />
                        <Form
                            autoComplete="off"
                            disabled={!(formik.isValid && formik.dirty)}
                            noValidate
                            onSubmit={handleSubmit}
                        >
                            <Stack spacing={2}>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Group *"
                                        value={formik.values.groupID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('groupID')}
                                        error={Boolean(touched.groupID && errors.groupID)}
                                        helperText={touched.groupID && errors.groupID}
                                        InputProps={{
                                            readOnly: !permissionList.isGroupFilterEnabled
                                        }}
                                    >
                                        <MenuItem key={0} value={0}>Select Group</MenuItem>
                                        {group.map((option) => (
                                            option.isActive == true ? <MenuItem key={option.groupID} value={option.groupID}>
                                                {option.groupName}
                                            </MenuItem> : null
                                        ))}
                                    </TextField>
                                    <FormControl fullWidth error={Boolean(touched.operationEntityID && errors.operationEntityID)}>
                                        <InputLabel id="multi-select-label">Fresh Collection Center *</InputLabel>
                                        <Select
                                            className="custom-select"
                                            labelId="multi-select-label"
                                            id="multi-select"
                                            multiple
                                            size="small"
                                            value={selectedOptions}
                                            onChange={handleSelectChange}
                                            label="Fresh Collection Center "
                                            disabled={!permissionList.isFactoryFilterEnabled}
                                            renderValue={(selected) => renderSelectedValue(selected)}
                                        >
                                            <MenuItem key={0} value={''}>
                                                <Checkbox checked={selectedOptions.length === factory.length} color="primary" />
                                                All Fresh Collection Center
                                            </MenuItem>
                                            {factory.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                    <Checkbox checked={selectedOptions.indexOf(option.value) > -1} color="primary" />
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {touched.operationEntityID && errors.operationEntityID && (
                                            <FormHelperText>{errors.operationEntityID}</FormHelperText>
                                        )}
                                        {selectedOptions.length > 0 && (
                                            <IconButton onClick={handleClearSelection} style={{ position: 'absolute', top: '50%', right: '24px', transform: 'translateY(-50%)' }}>
                                                {!permissionList.isFactoryFilterEnabled ? null :
                                                    <ClearIcon />}
                                            </IconButton>
                                        )}
                                    </FormControl>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DatePicker
                                            label="Date *"
                                            value={toDate}
                                            onChange={(newValue) => {
                                                setToDate(newValue);
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    error={false}
                                                    helperText={null}
                                                    {...params}
                                                />
                                            )}
                                        />
                                    </LocalizationProvider>
                                    <Grid><Button
                                        type="button"
                                        variant="outlined"
                                        color='error'
                                        onClick={() => clearAll()}
                                    > Clear</Button>
                                    </Grid>
                                    <Grid>
                                        <Button
                                            type="submit"
                                            color='secondary'
                                            variant="outlined"
                                        >Search</Button>
                                    </Grid>
                                </Stack>
                            </Stack>
                            <br />
                            {isEnable == false ?
                                <Stack direction={{ xs: 'column', sm: 'row' }} style={{ marginBottom: '10px' }} justifyContent="right" spacing={2}>
                                    <TextField
                                        size="small"
                                        style={{ width: '300px' }}
                                        value={ytdAndMtdData.ytdAndMtdName}
                                        placeholder="Search"
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <Search />
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </Stack> : null}
                            <>
                                {ytdAndMtdDetails.length != 0 ? (
                                    <>
                                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                            <Card style={{ justifycontent: 'center' }}>
                                                <Paper className={classes.paper}>
                                                    <TableContainer className={classes.tableContainer} sx={{ maxHeight: 440 }}>
                                                        <Table size="small" aria-label="simple table">
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell align="left" style={{ fontWeight: "bold", verticalAlign: 'top', justifyContent: 'center' }}>FCC</TableCell>
                                                                    <TableCell align="center" style={{ fontWeight: "bold", verticalAlign: 'top', justifyContent: 'center' }}>Order&nbsp;Date&nbsp;&nbsp;&nbsp;&nbsp;</TableCell>
                                                                    <TableCell align="center" style={{ fontWeight: "bold", verticalAlign: 'top', justifyContent: 'center' }}>Qty&nbsp;Purchase&nbsp;(Kg)</TableCell>
                                                                    <TableCell align="center" style={{ fontWeight: "bold", verticalAlign: 'top', justifyContent: 'center' }}>FCC&nbsp;Purchase Value&nbsp;(Rs)</TableCell>
                                                                    <TableCell align="center" style={{ fontWeight: "bold", verticalAlign: 'top', justifyContent: 'center' }}>If&nbsp;Purchased&nbsp;From EC&nbsp;Value&nbsp;(Rs)</TableCell>
                                                                    <TableCell align="center" style={{ fontWeight: "bold", verticalAlign: 'top', justifyContent: 'center' }}>Value&nbsp;Saving&nbsp;(Rs)</TableCell>
                                                                    <TableCell align="center" style={{ fontWeight: "bold", verticalAlign: 'top', justifyContent: 'center' }}>Saving&nbsp;(%)</TableCell>
                                                                    <TableCell align="center" style={{ fontWeight: "bold", verticalAlign: 'top', justifyContent: 'center' }}>MTD&nbsp;FCC&nbsp;Purchase Value (Rs)</TableCell>
                                                                    <TableCell align="center" style={{ fontWeight: "bold", verticalAlign: 'top', justifyContent: 'center' }}>MTD&nbsp;If&nbsp;Purchase&nbsp;From EC Value (Rs)</TableCell>
                                                                    <TableCell align="center" style={{ fontWeight: "bold", verticalAlign: 'top', justifyContent: 'center' }}>MTD&nbsp;Value Saving (Rs)</TableCell>
                                                                    <TableCell align="center" style={{ fontWeight: "bold", verticalAlign: 'top', justifyContent: 'center' }}>MTD&nbsp;Saving&nbsp;(%)</TableCell>
                                                                    <TableCell align="center" style={{ fontWeight: "bold", verticalAlign: 'top', justifyContent: 'center' }}>MTD&nbsp;Operation Cost (Rs)</TableCell>
                                                                    <TableCell align="center" style={{ fontWeight: "bold", verticalAlign: 'top', justifyContent: 'center' }}>MTD&nbsp;Net&nbsp;Profit&nbsp;Of Center (Rs)</TableCell>
                                                                    <TableCell align="center" style={{ fontWeight: "bold", verticalAlign: 'top', justifyContent: 'center' }}>YTD&nbsp;FCC&nbsp;Purchase Value&nbsp;(Rs)</TableCell>
                                                                    <TableCell align="center" style={{ fontWeight: "bold", verticalAlign: 'top', justifyContent: 'center' }}>YTD&nbsp;If&nbsp;Purchase&nbsp;From EC Value (Rs)</TableCell>
                                                                    <TableCell align="center" style={{ fontWeight: "bold", verticalAlign: 'top', justifyContent: 'center' }}>YTD&nbsp;Value Saving&nbsp;(Rs)</TableCell>
                                                                    <TableCell align="center" style={{ fontWeight: "bold", verticalAlign: 'top', justifyContent: 'center' }}>YTD&nbsp;Saving&nbsp;(%)</TableCell>
                                                                    <TableCell align="center" style={{ fontWeight: "bold", verticalAlign: 'top', justifyContent: 'center' }}>YTD&nbsp;Operational Costs</TableCell>
                                                                    <TableCell align="center" style={{ fontWeight: "bold", verticalAlign: 'top', justifyContent: 'center' }}>YTD&nbsp;Net&nbsp;Profit&nbsp;Of Center (Rs)</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {ytdAndMtdDetails.map((group, i) => (
                                                                    <React.Fragment key={i}>
                                                                        {group.details.map((detail, j) => {
                                                                            return (
                                                                                <TableRow key={`${i}-${j}`}>
                                                                                    {j === 0 && (
                                                                                        <TableCell rowSpan={group.details.length} style={{ verticalAlign: 'top' }}>{group.factoryName}</TableCell>
                                                                                    )}
                                                                                    <TableCell style={{ verticalAlign: 'top', textAlign: 'left' }}>
                                                                                        {moment(detail.createdDate).format('YYYY-MM-DD')}
                                                                                    </TableCell>
                                                                                    <TableCell style={{ verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                                        {detail.dtnetAmount == 0 ? '-' : parseFloat(detail.dtnetAmount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                                    </TableCell>
                                                                                    <TableCell style={{ verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                                        {detail.dtfccPurchaseValue == 0 ? '-' : parseFloat(detail.dtfccPurchaseValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                                    </TableCell>
                                                                                    <TableCell style={{ verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                                        {detail.dtpurchaseFromECValue == 0 ? '-' : parseFloat(detail.dtpurchaseFromECValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                                    </TableCell>
                                                                                    <TableCell style={{ verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                                        {detail.dtValueSaving == 0 ? '-' : parseFloat(detail.dtValueSaving).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                                    </TableCell>
                                                                                    <TableCell style={{ verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                                        {detail.dtSaving == 0 ? '-' : parseFloat(detail.dtSaving).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                                    </TableCell>
                                                                                    <TableCell style={{ verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                                        {detail.mtdfccPurchaseValue == 0 ? '-' : parseFloat(detail.mtdfccPurchaseValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                                    </TableCell>
                                                                                    <TableCell style={{ verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                                        {detail.mtdpurchaseFromECValue == 0 ? '-' : parseFloat(detail.mtdpurchaseFromECValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                                    </TableCell>
                                                                                    <TableCell style={{ verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                                        {detail.mtdValueSaving == 0 ? '-' : parseFloat(detail.mtdValueSaving).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                                    </TableCell>
                                                                                    <TableCell style={{ verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                                        {detail.mtdSaving == 0 ? '-' : parseFloat(detail.mtdSaving).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                                    </TableCell>
                                                                                    <TableCell style={{ verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                                        {detail.mtdCost == 0 ? '-' : parseFloat(detail.mtdCost).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                                    </TableCell>
                                                                                    <TableCell style={{ verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                                        {detail.mtdNetProfit == 0 ? '-' : parseFloat(detail.mtdNetProfit).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                                    </TableCell>
                                                                                    <TableCell style={{ verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                                        {detail.ytdfccPurchaseValue == 0 ? '-' : parseFloat(detail.ytdfccPurchaseValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                                    </TableCell>
                                                                                    <TableCell style={{ verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                                        {detail.ytdpurchaseFromECValue == 0 ? '-' : parseFloat(detail.ytdpurchaseFromECValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                                    </TableCell>
                                                                                    <TableCell style={{ verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                                        {detail.ytdValueSaving == 0 ? '-' : parseFloat(detail.ytdValueSaving).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                                    </TableCell>
                                                                                    <TableCell style={{ verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                                        {detail.ytdSaving == 0 ? '-' : parseFloat(detail.ytdSaving).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                                    </TableCell>
                                                                                    <TableCell style={{ verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                                        {detail.ytdCost == 0 ? '-' : parseFloat(detail.ytdCost).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                                    </TableCell>
                                                                                    <TableCell style={{ verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                                        {detail.ytdNetProfit == 0 ? '-' : parseFloat(detail.ytdNetProfit).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                                    </TableCell>
                                                                                </TableRow>
                                                                            );
                                                                        })}
                                                                        <TableRow>
                                                                            <TableCell colSpan={2} style={{ fontWeight: "bold", verticalAlign: 'top', textAlign: 'left' }}>
                                                                                Sub Total
                                                                            </TableCell>
                                                                            <TableCell style={{ fontWeight: "bold", verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                                {group.dtnetAmount == 0 ? '-' : parseFloat(group.dtnetAmount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                            </TableCell>
                                                                            <TableCell style={{ fontWeight: "bold", verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                                {group.dtfccPurchaseValue == 0 ? '-' : parseFloat(group.dtfccPurchaseValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                            </TableCell>
                                                                            <TableCell style={{ fontWeight: "bold", verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                                {group.dtpurchaseFromECValue == 0 ? '-' : parseFloat(group.dtpurchaseFromECValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                            </TableCell>
                                                                            <TableCell style={{ fontWeight: "bold", verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                                {group.dtValueSaving == 0 ? '-' : parseFloat(group.dtValueSaving).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                            </TableCell>
                                                                            <TableCell style={{ fontWeight: "bold", verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                            </TableCell>
                                                                            <TableCell style={{ fontWeight: "bold", verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                                {group.mtdfccPurchaseValue == 0 ? '-' : parseFloat(group.mtdfccPurchaseValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                            </TableCell>
                                                                            <TableCell style={{ fontWeight: "bold", verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                                {group.mtdpurchaseFromECValue == 0 ? '-' : parseFloat(group.mtdpurchaseFromECValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                            </TableCell>
                                                                            <TableCell style={{ fontWeight: "bold", verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                                {group.mtdValueSaving == 0 ? '-' : parseFloat(group.mtdValueSaving).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                            </TableCell>
                                                                            <TableCell style={{ fontWeight: "bold", verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                            </TableCell>
                                                                            <TableCell style={{ fontWeight: "bold", verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                                {group.mtdCost == 0 ? '-' : parseFloat(group.mtdCost).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                            </TableCell>
                                                                            <TableCell style={{ fontWeight: "bold", verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                                {group.mtdNetProfit == 0 ? '-' : parseFloat(group.mtdNetProfit).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                            </TableCell>
                                                                            <TableCell style={{ fontWeight: "bold", verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                                {group.ytdfccPurchaseValue == 0 ? '-' : parseFloat(group.ytdfccPurchaseValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                            </TableCell>
                                                                            <TableCell style={{ fontWeight: "bold", verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                                {group.ytdpurchaseFromECValue == 0 ? '-' : parseFloat(group.ytdpurchaseFromECValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                            </TableCell>
                                                                            <TableCell style={{ fontWeight: "bold", verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                                {group.ytdValueSaving == 0 ? '-' : parseFloat(group.ytdValueSaving).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                            </TableCell>
                                                                            <TableCell style={{ fontWeight: "bold", verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                            </TableCell>
                                                                            <TableCell style={{ fontWeight: "bold", verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                                {group.ytdCost == 0 ? '-' : parseFloat(group.ytdCost).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                            </TableCell>
                                                                            <TableCell style={{ fontWeight: "bold", verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                                {group.ytdNetProfit == 0 ? '-' : parseFloat(group.ytdNetProfit).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    </React.Fragment>
                                                                ))}
                                                                <TableRow>
                                                                    <TableCell colSpan={2} style={{ fontWeight: "bold", verticalAlign: 'top', textAlign: 'left' }}>
                                                                        Total
                                                                    </TableCell>
                                                                    <TableCell style={{ fontWeight: "bold", verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                        {total.dtnetAmount == 0 ? '-' : parseFloat(total.dtnetAmount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                    </TableCell>
                                                                    <TableCell style={{ fontWeight: "bold", verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                        {total.dtfccPurchaseValue == 0 ? '-' : parseFloat(total.dtfccPurchaseValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                    </TableCell>
                                                                    <TableCell style={{ fontWeight: "bold", verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                        {total.dtpurchaseFromECValue == 0 ? '-' : parseFloat(total.dtpurchaseFromECValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                    </TableCell>
                                                                    <TableCell style={{ fontWeight: "bold", verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                        {total.dtValueSaving == 0 ? '-' : parseFloat(total.dtValueSaving).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                    </TableCell>
                                                                    <TableCell style={{ fontWeight: "bold", verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                    </TableCell>
                                                                    <TableCell style={{ fontWeight: "bold", verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                        {total.mtdfccPurchaseValue == 0 ? '-' : parseFloat(total.mtdfccPurchaseValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                    </TableCell>
                                                                    <TableCell style={{ fontWeight: "bold", verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                        {total.mtdpurchaseFromECValue == 0 ? '-' : parseFloat(total.mtdpurchaseFromECValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                    </TableCell>
                                                                    <TableCell style={{ fontWeight: "bold", verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                        {total.mtdValueSaving == 0 ? '-' : parseFloat(total.mtdValueSaving).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                    </TableCell>
                                                                    <TableCell style={{ fontWeight: "bold", verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                    </TableCell>
                                                                    <TableCell style={{ fontWeight: "bold", verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                        {total.mtdCost == 0 ? '-' : parseFloat(total.mtdCost).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                    </TableCell>
                                                                    <TableCell style={{ fontWeight: "bold", verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                        {total.mtdNetProfit == 0 ? '-' : parseFloat(total.mtdNetProfit).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                    </TableCell>
                                                                    <TableCell style={{ fontWeight: "bold", verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                        {total.ytdfccPurchaseValue == 0 ? '-' : parseFloat(total.ytdfccPurchaseValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                    </TableCell>
                                                                    <TableCell style={{ fontWeight: "bold", verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                        {total.ytdpurchaseFromECValue == 0 ? '-' : parseFloat(total.ytdpurchaseFromECValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                    </TableCell>
                                                                    <TableCell style={{ fontWeight: "bold", verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                        {total.ytdValueSaving == 0 ? '-' : parseFloat(total.ytdValueSaving).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                    </TableCell>
                                                                    <TableCell style={{ fontWeight: "bold", verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                    </TableCell>
                                                                    <TableCell style={{ fontWeight: "bold", verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                        {total.ytdCost == 0 ? '-' : parseFloat(total.ytdCost).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                    </TableCell>
                                                                    <TableCell style={{ fontWeight: "bold", verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                        {total.ytdNetProfit == 0 ? '-' : parseFloat(total.ytdNetProfit).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                    </TableCell>
                                                                </TableRow>
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                </Paper>
                                            </Card>
                                        </Stack>
                                    </>
                                ) : <SearchNotFound searchQuery="YTD and MTD Summary Report" />}</>
                        </Form>
                    </FormikProvider>
                    {ytdAndMtdDetails.length > 0 ?
                        <Box display="flex" justifyContent="flex-end" p={2}>
                            <Button
                                color="primary"
                                id="btnRecord"
                                type="submit"
                                variant="contained"
                                style={{ marginRight: '1rem' }}
                                className={classes.colorRecord}
                                onClick={() => createFile()}
                            >
                                EXCEL
                            </Button>
                            <ReactToPrint
                                documentTitle={"YTD and MTD Summary Report"}
                                trigger={() => <Button
                                    color="primary"
                                    id="btnRecord"
                                    type="submit"
                                    variant="contained"
                                    style={{ marginRight: '1rem', backgroundColor: 'red' }}
                                    className={classes.colorCancel}
                                >
                                    PDF
                                </Button>}
                                content={() => componentRef.current}
                            />
                            <div hidden={true}>
                                <CreatePDF ref={componentRef}
                                    ytdAndMtdDetails={ytdAndMtdDetails}
                                    searchData={selectedSearchValues}
                                    total={total}
                                />
                            </div>
                        </Box> : null}
                </Container>
            </Page>
        </>
    );
}

